import { Link } from "react-router-dom";

const HomeFinalCtaSection = () => {
  return (
    <section className="bg-[#080a58] text-white py-14 md:py-20 px-4">
      <div className="container mx-auto flex flex-col md:flex-row justify-between items-start md:items-center gap-8 md:gap-16">
        <div>
          <p className="flex items-center font-poppins gap-3 text-secondary text-sm font-extrabold tracking-[0.1em] uppercase mb-8">
            <span className="w-8 h-[3px] bg-secondary inline-block"></span>
            Choose your next step
          </p>
          <h2 className="text-white font-poppins tracking-[-0.04em] font-bold text-3xl md:text-[42px] mb-5">
            Build your skills—or build your team.
          </h2>
          <p className="text-[#d7dfff] font-poppins text-sm m-0">
            Both journeys start with one clear action.
          </p>
        </div>
        <div className="flex flex-wrap items-center gap-3">
          <Link
            to="/start"
            className="bg-secondary text-primary font-poppins rounded-xl min-h-[50px] px-6 inline-flex items-center gap-3 text-sm font-bold hover:-translate-y-0.5 transition-all"
          >
            Explore Programs
          </Link>
          <Link
            to="/hire"
            className="border border-white/55 font-poppins text-white rounded-xl min-h-[50px] px-6 inline-flex items-center gap-3 text-sm font-bold hover:bg-white/10 transition-all"
          >
            Hire Talent
          </Link>
        </div>
      </div>
    </section>
  );
};

export default HomeFinalCtaSection;
